import { Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { UserGuard } from '@app/utils/guards/user.guard';
import { AdminGuard } from '@utils/guards/admin.guard';

export const PRIVATE_ROUTES: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: 'inicio',
        loadChildren: () => import('@home/home.routes')
          .then(m => m.HOME_ROUTES),
      },
      {
        path: 'gestion-cobranza',
        loadChildren: () => import('@collection-management/collection-management.routes')
          .then(m => m.COLLECTION_MANAGEMENT_ROUTES),
        canLoad: [AdminGuard]
      },
      {
        path: 'plantillas',
        loadChildren: () => import('@templates/templates.routes')
          .then(m => m.TEMPLATES_ROUTES),
        canLoad: [UserGuard],
        data: {
          module: 'notifications',
        },
      },
      {
        path: 'generar-reportes',
        loadChildren: () => import('@generate-reports/generate-reports.routes')
          .then(m => m.GENERATE_REPORTS_ROUTES),
        canLoad: [UserGuard],
        data: {
          module: 'generation_of_reports'
        }
      },
      {
        path: 'alertas',
        loadChildren: () => import('@alarms/alarms.routes')
          .then(m => m.ALARMS_ROUTES),
        canLoad: [UserGuard],
        data: {
          module: 'alarms'
        }
      },
      {
        path: 'deudores',
        loadChildren: () => import('@debtors/debtors.routes')
          .then(m => m.DEBTORS_ROUTES),
        canLoad: [UserGuard],
        data: {
          module: 'debtors'
        }
      },
      {
        path: 'usuarios',
        loadChildren: () => import('@users/users.routes')
          .then(m => m.USERS_ROUTES),
        canLoad: [UserGuard],
        data: {
          module: 'users'
        }
      },
      {
        path: 'roles',
        loadChildren: () => import('@roles/roles.routes')
          .then(m => m.ROLES_ROUTES),
        canLoad: [UserGuard],
        data: {
          module: 'roles'
        }
      },
      {
        path: 'procesos-cobranza',
        loadChildren: () => import('@collection-processes/collection-processes.routes')
          .then(m => m.COLLECTION_PROCESSES_ROUTES),
        canLoad: [UserGuard],
        data: {
          module: 'collection_process'
        }
      },
      {
        path: 'procesos-legales',
        loadChildren: () => import('@legal-processes/legal-processes.routes')
          .then(m => m.LEGAL_PROCESSES_ROUTES),
        canLoad: [UserGuard],
        data: {
          module: 'legal_process'
        }
      },
      {
        path: 'restructuraciones',
        loadChildren: () => import('@restructurings/restructurings.routes')
          .then(m => m.RESTRUCTURING_PROCESSES_ROUTES),
        canLoad: [UserGuard],
        data: {
          module: 'restructuring_process'
        }
      },
      {
        path: 'provisiones-pago',
        loadChildren: () => import('@payment-provision/payment-provision.routes')
          .then(m => m.PAYMENT_PROVISION_ROUTES),
        canLoad: [UserGuard],
        data: {
          module: 'payment_provision'
        }
      },
      {
        path: 'financiero',
        loadChildren: () => import('@payment-cycles/payment-cycles.routes')
          .then(m => m.PAYMENT_CYCLES_ROUTES),
        canLoad: [UserGuard],
        data: {
          module: 'collection_process'
        }
      },
      {
        path: 'historial-autorizaciones',
        loadChildren: () => import('@authorization-history/authorization-history.routes')
          .then(m => m.AUTHORIZATION_HISTORY_ROUTES),
        canLoad: [UserGuard],
        data: {
          module: 'authorization_process'
        }
      },
      {
        path: 'cobertura-juridica',
        loadChildren: () => import('@legal-coverage/legal-coverage.routes')
          .then(m => m.LEGAL_COVERAGE),
          canLoad: [UserGuard],
          data: {
            module: 'legal_coverage_process'
          }
      },
      {
        path: 'casa-cobranza',
        loadChildren: () => import('@collection-house/collection-house.routes')
          .then(m => m.COLLECTION_HOUSE_ROUTES),
        canLoad: [UserGuard],
        data: {
          module: 'collection_house'
        }
      },
      {
        path: 'acuerdos-pago',
        loadChildren: () => import('@payment-agreements/payment-agreements.routes')
          .then(m => m.PAYMENT_AGREEMENTS_ROUTES),
        canLoad: [UserGuard],
        data: {
          module: 'payment_agreement'
        }
      },
      {
        path: 'notificaciones',
        loadChildren: () => import('@notifications/notifications.routes')
          .then(m => m.NOTIFICATIONS_ROUTES),
        canLoad: [UserGuard],
        data: {
          module: 'notifications'
        }
      },
      {
        path: 'indicadores-financieros',
        loadChildren: () => import('@financial-indicators/financial-indicators.routes')
          .then(m => m.FINANCIAL_INDICATORS_ROUTES),
        canLoad: [UserGuard],
        data: {
          module: 'financial_indicators'
        }
      },
      {
        path: 'historial-pago',
        loadChildren: () =>
          import('@payment-review/payment-review.routes').then(
            (m) => m.PAYMENT_REVIEW_ROUTES,
          ),
        canLoad: [UserGuard],
        data: {
          module: 'collection_process',
        },
      },
      {
        path: 'liquidacion',
        loadChildren: () => import('@liquidations/liquidations.routes')
          .then(m => m.LIQUIDATIONS_ROUTES)
      },
      {
        path: 'consultas-bases-datos',
        loadChildren: () => import('@database-query/database-query.routes')
          .then(m => m.DATABASE_QUERY_ROUTES)
      },
      {
        path: 'compromisos-pago',
        loadChildren: () => import('@payment-commitments/payment-commitments.routes')
          .then(m => m.PAYMENT_COMMITMENTS_ROUTES),
        canLoad: [UserGuard],
        data: {
          module: 'payment_commitment',
        },
      },
      {
        path: 'score-cobranza',
        loadChildren: () => import('@private/modules/collection-score/collection-score.routes')
          .then(m => m.COLLECTION_SCORE),
        canLoad: [AdminGuard],
        data: {
          module: 'collection_score'
        }
      },
      {
        path: '**',
        redirectTo: 'inicio'
      }
    ]
  },
  {
    path: '**',
    redirectTo: '/inicio'
  }
];
